module.exports = __webpack_public_path__ + "static/media/0.ac06887e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/0.png
// module id = 1646
// module chunks = 0